import React, { useEffect, useState } from 'react';
import OrderITem from '../OrderItem/OrderITem';
import TourItem from '../TourItem/TourItem';
import './Order.css';

const Order = () => {
    const [tours, setTours] = useState([]);
    const [tour, setTour] = useState([]);
    

    useEffect(()=>{
        fetch('https://secure-plains-53229.herokuapp.com/items')
        .then(res => res.json())
        .then(data => setTours(data))
    },[])

    const handleAddBuyNow = (tours) =>{
        const newTour = [...tour, tours];
        setTour(newTour);
    }

    return (
        <div id="order">
            <h1 className="fs-1 text-center my-5">Your tours order Items</h1>
            <div className="order-container">
                <div className="border border-1 p-5">
                    {
                        tours.map(tour => <OrderITem
                        key={tour.id}
                        tour={tour}
                        handleAddBuyNow={handleAddBuyNow}
                        ></OrderITem>)
                    }
                
                </div>
                <div className="border border-1 p-5">
                   <TourItem
                        tour={tour}
                   ></TourItem>
                </div>
            </div>
        </div>
    );
};

export default Order;